module.exports = __webpack_public_path__ + "static/media/github_icon.e2a62886.png";